module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/Group 8-19be7792a78d6ac8890dc8c6d2d185e1.png";